  // This variable is used to set and compare the values of dropdown
  export const OPTION_SELECT_EMPTY = "--select--";